import { useTranslation, Trans } from "react-i18next";
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; // Import AuthContext
import { signOut } from 'firebase/auth';
import { auth } from './../../firebaseConfig'; // Import Firebase auth instance
import './Header.css';
import Logo from './../../assets/logos/LogoColour.svg';
import OrangeLogo from './../../assets/logos/orangelogo.svg';
import GradientButton from '../ui/GradientButton/GradientButton';
import OrangeGradientButton from '../ui/OrangeGradientButton/OrangeGradientButton';
import ProfilePhoto from './../../assets/Images/pricing/1.png';
import LogoutIcon from './../../assets/icons/logout.svg';
import i18n from "../../i18n";
import EnglishFlag from "../../assets/icons/ui/eng.svg";
import RussianFlag from "../../assets/icons/ui/ru.svg";


const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation(); // Get the current location
  const { user } = useAuth(); // Get user from AuthContext
  const { t } = useTranslation(); 
  const [currentLang, setCurrentLang] = useState(i18n.language);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50); // Add background when scrolled more than 50px
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Logout handler
  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log('User logged out');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };
  const switchLanguage = () => {
    const newLang = currentLang === "en" ? "ru" : "en";
    i18n.changeLanguage(newLang);
    localStorage.setItem("language", newLang);
    setCurrentLang(newLang); // ✅ Update state to reflect the change
  };

  return (
    <header className={scrolled ? 'header scrolled' : 'header'}>
      <div className="header-content">
        <nav className="navmain">
          <ul className="nav-links">
          <li>
  <Link to="/">
    <img
      src={location.pathname === '/teens' ? OrangeLogo : Logo}
      alt="Logo"
      className="logo-header"
    />
  </Link>
</li>

            <li>
              <Link
                to="/"
                className={location.pathname === '/' ? 'nav active' : 'nav'}
              >
                <Trans>home</Trans>
              </Link>
            </li> 
            <li>
              <Link
                to="/masters"
                className={location.pathname === '/masters' ? 'nav active' : 'nav'}
              >
                <Trans>masters</Trans>
              </Link>
            </li>
            {/* <li>
              <Link
                to="/programs"
                className={location.pathname === '/programs' ? 'nav active' : 'nav'}
              >
                <Trans>programs</Trans>
              </Link>
            </li> */}
            <li>
              <Link
                to="/events"
                className={location.pathname === '/events' ? 'nav active' : 'nav'}
              >
                <Trans>events</Trans>
              </Link>
            </li>
            
            <li>
              <Link
                to="/teens"
                className={location.pathname === '/teens' ? 'nav activeTeens' : 'nav'}
              >
                <Trans>teens</Trans>
              </Link>
            </li>
            
            
          
            <li>
              <Link
                to="/calendar"
                className={location.pathname === '/calendar' ? 'nav active' : 'nav'}
              >
                <Trans>calendar</Trans>
              </Link>
            </li>
            <li>
  {user ? (
    <div className="user-info">
      {location.pathname === '/teens' ? (
        <OrangeGradientButton width='190px'>
          <div className="user-container">
            <img
              src={user.photoURL || ProfilePhoto} // Default avatar if no photoURL
              alt="User Avatar"
              className="user-avatar"
            />
            <span className="username">
              {user.displayName || user.email || 'User'}
            </span>
            <img
              src={LogoutIcon}
              alt="Logout"
              className="logout-icon"
              onClick={handleLogout}
              title="Logout"
            />
          </div>
        </OrangeGradientButton>
      ) : (
        <GradientButton>
          <div className="user-container">
            <img
              src={user.photoURL || ProfilePhoto} // Default avatar if no photoURL
              alt="User Avatar"
              className="user-avatar"
            />
            <span className="username">
              {user.displayName || user.email || 'User'}
            </span>
            <img
              src={LogoutIcon}
              alt="Logout"
              className="logout-icon"
              onClick={handleLogout}
              title="Logout"
            />
          </div>
        </GradientButton>
      )}
    </div>
  ) : (
    <Link to="/login">
      {location.pathname === '/teens' ? (
        <OrangeGradientButton width='190px'><Trans>login_signup</Trans></OrangeGradientButton>
      ) : (
        <GradientButton><Trans>login_signup</Trans></GradientButton>
      )}
    </Link>
    
  )}
</li>
<li className="language-switcher" onClick={switchLanguage}>
              {currentLang === "en" ? (
                <img src={EnglishFlag} alt="Switch to Russian" className="flag-icon" />
              ) : (
                <img src={RussianFlag} alt="Switch to English" className="flag-icon" />
              )}
            </li>

          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
